module.exports = __webpack_public_path__ + "static/media/google-authenticator.966ad16a.svg";